import React, { useEffect, useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import MyPage from "./MyPage";

function Bannar() {
  const [slides, setSlides] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    // ✅ JSON (UI)
    fetch("/api/banner.json")
      .then(res => res.json())
      .then(data => setSlides(data.slides));

    // ✅ XML (exam / proof)
    fetch("/api/banner.xml")
      .then(res => res.text())
      .then(() => console.log("Banner XML loaded"));
  }, []);

  useEffect(() => {
    if (!slides.length) return;

    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides]);

  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + slides.length) % slides.length);
  };

  //if (!slides.length) return null;

  return (
    <>
     {/* ✅ SEO */}
     <MyPage
        title="Home | Thrissur Jilla Pravasi Kootayma"
        description="Thrissur Pravasi families united through community engagement and social welfare."
        keywords="Thrissur Pravasi, Community Engagement, Pravasi Activities"
      />
      <section className="hero-slider">
        {/* Arrows */}
        <div className="slider-arrow left-arrow" onClick={prevSlide}>
          <FaChevronLeft />
        </div>
        <div className="slider-arrow right-arrow" onClick={nextSlide}>
          <FaChevronRight />
        </div>

        {slides.map((slide, index) => (
          <div
            key={index}
            className={`hero-banner ${index === currentSlide ? "active" : ""}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="banner-overlay"></div>

            <div className="banner-content">
              <h1>
                {slide.title} <span>{slide.highlight}</span>
              </h1>

              <p>{slide.description}</p>

              {slide.buttons.map((btn, i) => (
                <Link
                  key={i}
                  to={btn.link}
                  className={`white-edge-button ${btn.class}`}
                >
                  <span className="btn-label">{btn.label}</span>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </section>

      {/* ===== CSS (Desktop + Mobile from your style.css) ===== */}
      <style>{`

      @import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;700;900&display=swap');

/* HERO FONT */
.hero-slider,
.hero-banner,
.banner-content,
.banner-content h1,
.banner-content p,
.white-edge-button {
  font-family: 'Merriweather', sans-serif;
}


.hero-banner {
  position: absolute;
  height: 100vh;
}
        .hero-slider {
          position: relative;
          height: 100vh;
          overflow: hidden;
        }

        /* Arrows */
        .slider-arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          font-size: 22px;
          color: #fff;
          background: rgba(0,0,0,0.4);
          padding: 12px;
          border-radius: 50%;
          cursor: pointer;
          z-index: 5;
        }

        .left-arrow { left: 20px; }
        .right-arrow { right: 20px; }

        /* Banner */
        .hero-banner {
          position: absolute;
          inset: 0;
          background-size: cover;
          background-position: center;
          opacity: 0;
          transform: scale(1.05);
          transition: opacity 1s ease-in-out, transform 2s ease-in-out;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
        }

        .hero-banner.active {
          opacity: 1;
          transform: scale(1);
          z-index: 1;
        }

        .banner-content {
          color: #fff;
          max-width: 1200px;
          padding: 20px;
          opacity: 0;
          transform: translateY(40px);
          transition: opacity 1s ease-out, transform 1s ease-out;
          margin-top: 100px;
        }

        .hero-banner.active .banner-content {
          opacity: 1;
          transform: translateY(0);
        }

        .banner-content h1 {
          font-size: 50px;
          margin-bottom: 20px;
          word-spacing: 7px;
          letter-spacing: 2px;
              font-weight: 700;
        }

        .banner-content h1 span {
          color: var(--primary-color);
		  width: 100%;
    display: block;
        }

        .banner-content p {
          font-size: 21px;
          line-height: 1.6;
          margin-bottom: 30px;
          font-weight: 400;
    color: var(--white-color);
    font-family: var(--secondary-font-family);
        }
    /* BACKGROUND OVERLAY */
.banner-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.45); /* 🔥 opacity ochhi / vadhi */
  z-index: 0;
}

/* CONTENT ABOVE OVERLAY */
.hero-banner {
  position: absolute;
}

.banner-content {
  position: relative;
  z-index: 1;
}


        .white-edge-button {
          display: inline-block;
          margin: 0 10px;
          padding: 14px 36px;
          border: 2px solid #fff;
          color: #fff;
          text-decoration: none;
          font-weight: 600;
        }

        /* Animations */
        .hero-banner.active h1 {
          animation: slideInLeft 1s ease-out forwards;
        }

        .hero-banner.active p {
          animation: slideInRight 1s ease-out forwards;
          animation-delay: 0.3s;
        }

        .hero-banner.active .white-edge-button {
          animation: fadeUp 0.8s ease-out forwards;
          animation-delay: 0.6s;
          opacity: 0;
        }

        @keyframes slideInLeft {
          from { transform: translateX(-60px); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }

        @keyframes slideInRight {
          from { transform: translateX(60px); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }

        @keyframes fadeUp {
          from { transform: translateY(30px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }

        /* ================= MOBILE RESPONSIVE (FROM YOUR CSS) ================= */
        @media (max-width: 768px) {

          .slider-arrow {
            display: none;
          }

          .hero-slider {
            height: 60vh;
          }

          .hero-banner {
            height: 70vh;
          }

          .banner-content {
            margin-top: 60px;
            padding: 10px;
          }

          .banner-content h1 {
            font-size: 28px;
            line-height: 1.3;
            letter-spacing: 1px;
            word-spacing: 4px;
          }

          .banner-content p {
            font-size: 14px;
            line-height: 1.5;
            margin-bottom: 20px;
            padding: 0 10px;
          }

          .white-edge-button {
            padding: 10px 20px;
            font-size: 14px;
            margin-bottom: 10px;
          }

          .white-edge-button + .white-edge-button {
            margin-left: 0;
          }
        }
          /* ===== GREEN BUTTONS IN BANNER ===== */

/* ===== BANNER GREEN BUTTON WITH BLACK HOVER ===== */

.hero-slider .white-edge-button {
  display: inline-block;
  margin: 0 10px;
  padding: 14px 36px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.35s ease;
  border-radius: 10px;   /* 🔥 rounded */
}

.hero-slider .know-more {
  background: #9bc53d;
  border: 2px solid #9bc53d;
  color: #000;
}

/* hover */
.hero-slider .know-more:hover {
  background: #000;
  color: #fff;
  border: 2px solid #fff;
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.45);
}

.hero-slider .contact-us {
   color: rgb(255, 255, 255);      /* 🔥 white */
  border: 2px solid #fff;
  background: transparent;  /* optional – classy look */
  color: #fcf7f7;
}

/* hover */
.hero-slider .contact-us:hover {
  background: transparent;  /* optional – classy look */
      color: rgb(255, 255, 255);
    border-color: rgb(255, 255, 255);
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.45);
}
  
      `}</style>
    </>
  );
}

export default Bannar;
